export default {
      id: "arrow-down-usage",
      viewBox: "0 0 11 7",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }